import { useTranslation } from 'react-i18next'
import { ScrollFade } from '@/components/ScrollFade'

const TILES = ['noDataMovement', 'encryptedBus', 'selfHostable'] as const

export function TrustStrip() {
  const { t } = useTranslation()
  return (
    <section className="max-w-7xl mx-auto px-5 md:px-8 py-10 md:py-12">
      <ScrollFade as="h2" className="text-3xl md:text-4xl font-bold font-display mb-8 md:mb-10">
        {t('trustStrip.heading')}
      </ScrollFade>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6">
        {TILES.map((key, i) => (
          <ScrollFade
            key={key}
            delay={i * 80}
            className="p-5 rounded-lg border border-mono-800/[0.16] dark:border-mono-100/[0.16] bg-gradient-to-b from-mono-800/[0.06] to-mono-800/[0.02] dark:from-mono-100/[0.06] dark:to-mono-100/[0.02]"
          >
            <div className="text-base font-semibold mb-2">{t(`trustStrip.${key}`)}</div>
            <p className="text-lg opacity-75 leading-relaxed">{t(`lorem:trustStrip.${key}`)}</p>
          </ScrollFade>
        ))}
      </div>
    </section>
  )
}
